import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import styles from './styles.scss';

// AdyenForm supports displaying Adyen dropin
// component. We change prices by updating the amount, sessionId and
// sessionData values. We would do this for going between recurring changes
// on the ui, i.e. monthly to yearly.
const AdyenForm = ({
  sessionData,
  sessionId,
  clientKey,
  environment,
  currency,
  amount
}) => {
  const adyenContainer = useRef(null);
  const [checkoutFactory, setCheckoutFactory] = useState(null);
  // Using a reference for the checkout component instead of a state
  // to avoid double rendering of going from monthly to yearly and vice versa
  const checkoutComponentRef = useRef(null);
  // Adyen configuration for component factory.
  // Currently, we are just using the default dropin
  // component. As we iterate, we adjust this configuration
  // to include specific country payment configurations.
  const config = {
    environment,
    clientKey,
    analytics: {
      enabled: false
    }
  };
  const isValidSessionId = sessionId !== '' && sessionId !== null;

  // Only set sessionId and sessionData when we
  // have valid data, otherwise factory will fail
  // with error. We can have an empty sessionId
  // when we are minting a new sessionId on the
  // server.
  if (isValidSessionId) {
    config.session = {
      id: sessionId,
      sessionData
    };
    config.amount = {
      value: amount,
      currency
    };
  }

  useEffect(() => {
    const createCheckout = async () => {
      const factory = await AdyenCheckout({
        ...config,
        onPaymentCompleted: (response, _component) => {
          console.log(response.resultCode);
          console.log(_component);
        },
        onError: (error, _component) => {
          console.error(error);
          console.log(_component);
        }
      });

      return factory;
    };

    createCheckout()
      .then((factory) => {
        setCheckoutFactory(factory);
      })
      .catch((e) => console.log('\terror creating checkout config: %o', e));
  }, []);

  if (checkoutFactory && isValidSessionId) {
    checkoutFactory.update(config);

    if (checkoutComponentRef.current) {
      checkoutFactory.remove(checkoutComponentRef.current);
    }

    checkoutComponentRef.current = checkoutFactory.create('dropin');
    checkoutComponentRef.current.mount(adyenContainer.current);
  }

  return (
    <div className={styles.checkoutForm}>
      <div ref={adyenContainer} className="payment" />
    </div>
  );
};

AdyenForm.propTypes = {
  sessionData: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  clientKey: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
};

export default AdyenForm;
